import { faLayerMinus, faLayerPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography, cn } from "@tosize/ui";
import type { ComponentProps } from "react";
import type { TaxonomyCardProps } from "~/components/cards/TaxonomyCard";

interface ShowMoreCardProps extends ComponentProps<"button"> {
	name: string;
	open: boolean;
	variant: TaxonomyCardProps["variant"];
}

export function ShowMoreCard({ name, open, variant, className, ...props }: ShowMoreCardProps) {
	return (
		<button
			type="button"
			title={name}
			className={cn(
				"group m-2 w-full shrink-0 cursor-pointer snap-start flex-col overflow-hidden rounded-xl border border-shades bg-white text-primary-medium leading-tight first:ml-0 last:mr-0 hover:underline focus:outline-none focus-visible:underline lg:m-0 lg:max-w-none lg:border-none lg:shadow lg:focus-visible:shadow-md lg:hover:shadow-md",
				{
					"max-w-[calc(310px/1.375)]": variant === "product" || variant === "category",
					"max-w-[calc(310px/1.6)]": variant === "alternative",
					"max-w-[calc(310px/1.5)]": variant === "nav",
				},
				className,
			)}
			{...props}
		>
			<div className="flex aspect-[2/1] w-full items-center justify-center">
				<FontAwesomeIcon
					icon={open ? faLayerMinus : faLayerPlus}
					fixedWidth
					className="mt-3 text-6xl text-primary-medium"
				/>
			</div>

			<div className="mt-1 mb-2 flex min-h-[2.5rem] w-full grow justify-center px-4 text-center">
				<Typography
					variant="paragraph-bold"
					component="span"
					color="text-primary-medium"
					size={variant === "alternative" ? "text-sm" : undefined}
				>
					{name}
				</Typography>
			</div>
		</button>
	);
}
